import { render, staticRenderFns } from "./costStat.vue?vue&type=template&id=2d8e7c26&"
import script from "./costStat.vue?vue&type=script&lang=js&"
export * from "./costStat.vue?vue&type=script&lang=js&"
import style0 from "./costStat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports